import { NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransactionsRoutingModule } from './transactions-routing.module';
import { SalesQuotationComponent } from './sales-quotation/sales-quotation.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { VexPageLayoutComponent } from 'src/@vex/components/vex-page-layout/vex-page-layout.component';
import { VexPageLayoutContentDirective } from 'src/@vex/components/vex-page-layout/vex-page-layout-content.directive';
import { VexSecondaryToolbarComponent } from 'src/@vex/components/vex-secondary-toolbar/vex-secondary-toolbar.component';
import { LoadingOrderComponent } from './loading-order/loading-order.component';
import { EditLoadingOrderComponent } from './loading-order/edit-loading-order/edit-loading-order.component';
import { VexPageLayoutHeaderDirective } from 'src/@vex/components/vex-page-layout/vex-page-layout-header.directive';
import { CreateUpdateSalesQuotationComponent } from './sales-quotation/create-update-sales-quotation/create-update-sales-quotation/create-update-sales-quotation.component';
import { CustomersListComponent } from './shared-components/customers-list/customers-list.component';
import { AddLoadingOrderComponent } from './loading-order/add-loading-order/add-loading-order.component';
import { ProductsListComponent } from './shared-components/products-list/products-list.component';
import { SalesOrderComponent } from './sales-order/sales-order.component';
import { SalesDeliveryComponent } from './sales-delivery/sales-delivery.component';
import { CreateUpdateSalesDeliveryComponent } from './sales-delivery/create-update-sales-delivery/create-update-sales-delivery.component';
import { CreateUpdateSalesOrderComponent } from './sales-order/create-update-sales-order/create-update-sales-order.component';
import { ViewLoadingOrderComponent } from './loading-order/view-loading-order/view-loading-order.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';
import { FormsModule } from '@angular/forms';
import { PurchaseOrderComponent } from './purchase-order/purchase-order.component';
import { CreateUpdatePurchaseOrderComponent } from './purchase-order/create-update-puchase-order/create-update-purchase-order.component';
import { LoadingOrderPdfComponent } from 'src/app/shared/modules/print-templates/loading-order-pdf/loading-order-pdf.component';
import { PurchaseOrderPdfComponent } from 'src/app/shared/modules/print-templates/purchase-order-pdf/purchase-order-pdf.component';
import { SalesQuotationPdfComponent } from 'src/app/shared/modules/print-templates/sales-quotation-pdf/sales-quotation-pdf.component';
import { SalesOrderPdfComponent } from 'src/app/shared/modules/print-templates/sales-order-pdf/sales-order-pdf.component';


@NgModule({
    declarations: [SalesQuotationComponent, LoadingOrderComponent, EditLoadingOrderComponent, 
      CustomersListComponent, CreateUpdateSalesQuotationComponent, AddLoadingOrderComponent,
      ProductsListComponent,SalesOrderComponent,SalesDeliveryComponent,CreateUpdateSalesDeliveryComponent
      ,CreateUpdateSalesOrderComponent,ViewLoadingOrderComponent,PurchaseOrderComponent,CreateUpdatePurchaseOrderComponent],
  imports: [
    CommonModule,
    TransactionsRoutingModule,
    SharedModule,
    MatChipsModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    MatNativeDateModule,
    FormsModule,
    LoadingOrderPdfComponent,
    PurchaseOrderPdfComponent,
    SalesQuotationPdfComponent,
    SalesOrderPdfComponent
],
})
export class TransactionsModule {}
